import MobileDetect from 'mobile-detect';
import {isApplyCustomLayout} from '../common/custom-layout/const'
// 判断移动端
const md = new MobileDetect (window.navigator.userAgent);

function isMobile () {
  return md.mobile ()&&!md.tablet();
}

function mobileStyleInit () {
  // 移动端兼容vm单位
  const viewportUnitsBuggyfill = require ('viewport-units-buggyfill');
  const viewportUnitsBuggyfillHacks = require ('viewport-units-buggyfill/viewport-units-buggyfill.hacks');
  viewportUnitsBuggyfill.init ({
    hacks: viewportUnitsBuggyfillHacks,
  });
  // 移动端样式
  require ('mobile-style');
}

function pcStyleInit () {
  // PC端样式
  require ('pc-style');
}

function deviceInit () {
  // 定制pc端布局
  if (isApplyCustomLayout) {
    pcStyleInit ();
    return
  }
  if (isMobile ()) {
    mobileStyleInit ();
  } else {
    pcStyleInit ();
  }
}

export {isMobile, mobileStyleInit, pcStyleInit, deviceInit};



// WEBPACK FOOTER //
// ./src/service/deviceDetectService.js